
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1.25","y":"1.875","width":"37.5","height":"24.375","rx":"2","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M2.5 1.667h35a1.667 1.667 0 011.667 1.667v23.333H.833V3.334A1.667 1.667 0 012.5 1.667z","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M39.167 31.667a1.667 1.667 0 01-1.667 1.667h-35a1.667 1.667 0 01-1.667-1.667v-5h38.334v5z","fill":"#fff","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20 33.333v5m-7.5 0h15","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.333 12.917L22.917 15v.834l-4.584 2.5v-5.417z","fill":"#fff"}}),_c('path',{attrs:{"d":"M19.03 17.91a.625.625 0 01-.905-.558V13.75a.625.625 0 01.904-.56l3.603 1.802a.624.624 0 010 1.118l-3.603 1.8z","stroke":"#F2994A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    